import { useMemo } from 'react';
import { useQueryParam } from '../../../utils/hooks/useQueryParam';

export const defaultPaginationParamName = 'page';

export const useSMLPaginationParam = (paramName: string = defaultPaginationParamName) => {
  const pageParam = useQueryParam(paramName, null, '1');
  const currentPage = useMemo(() => {
    const parsed = parseInt(pageParam, 10);
    return !Number.isNaN(parsed) && parsed > 0 ? parsed : 1;
  }, [pageParam]);

  return {
    currentPage,
  };
};
